import { GET_USER, GET_RATINGS, CHECKED_CAN_ADD_RATING, RATING_CHANGE, LOAD_USER_COMMENT } from '../../actions';

const newUser = {
  gender: '',
  birthday: '',
  name: '',
  prename: '',
  plz: '',
  place: '',
  aboutMe: '',
  requestUid: '',
  rating: 0,
  comment: '',
  houseSituation: ''
};
const userReducer = (oldState = {
  userVm: newUser,
  ratingVm: new Map()
}, action) => {
  const { userVm, ratingVm } = oldState;
  switch (action.type) {
    case GET_USER:
    {
      const { response, uid } = action;
      return {
        ...oldState,
        userVm: {
          ...newUser,
          ...response,
          uid
        }
      }; }
    case GET_RATINGS:
    {
      const { ratings } = action;

      return {
        ...oldState,
        ratingVm: ratings
      };
    }
    case LOAD_USER_COMMENT:
    {
      const { user, key } = action;
      const rating = ratingVm.get(key);
      return {
        ...oldState,
        ratingVm: new Map(ratingVm.set(key, { ...rating, owner: user }))
      };
    }
    case CHECKED_CAN_ADD_RATING:
    {
      const { response } = action;
      const keys = response.map(x => x.id);
      return {
        ...oldState,
        userVm: {
          ...userVm,
          requestUid: keys && keys[0]
        }
      };
    }
    case RATING_CHANGE:
    {
      const { name, value } = action;
      return {
        ...oldState,
        userVm: {
          ...userVm,
          [name]: value
        }
      };
    }
    default:
      return oldState;
  }
};

export default userReducer;



// WEBPACK FOOTER //
// ./src/pages/User/userReducer.js